import React from 'react';

import { Divider } from './Divider';
import { EmailSection } from './EmailSection';
import { ModalContent } from './ModalContent';
import { ModalHeader } from './ModalHeader';
import { OAuthSection } from './OAuthSection';

interface AuthModalContentProps {
  onClose: () => void;
  handleGoogleLogin: () => void;
  handleAppleLogin: () => void;
  handleMicrosoftLogin: () => void;
  handleGitHubLogin: () => void;
  handleEmailLogin: (email: string, password?: string, displayName?: string, country?: string, stateCode?: string) => void;
  isLoading: boolean;
  error: string | undefined;
  setError: (error: string | undefined) => void;
}

const AuthHeader: React.FC<{ onClose: () => void }> = ({ onClose }) => (
  <ModalHeader
    title="Log in or sign up"
    subtitle={(
      <span>
        By signing in or signing up you agree with our
        {' '}
        <a href="/terms" className="auth-legal-link underline hover:text-gray-900 transition-colors">Terms &amp; Conditions</a>
        {' '}
        and
        {' '}
        <a href="/privacy" className="auth-legal-link underline hover:text-gray-900 transition-colors">Privacy Policy</a>
      </span>
    )}
    onClose={onClose}
  />
);

const AuthOAuth: React.FC<{
  handleGoogleLogin: () => void;
  handleAppleLogin: () => void;
  handleMicrosoftLogin: () => void;
  handleGitHubLogin: () => void;
  isLoading: boolean;
}> = ({ handleGoogleLogin, handleAppleLogin, handleMicrosoftLogin, handleGitHubLogin, isLoading }) => (
  <OAuthSection
    onGoogleClick={handleGoogleLogin}
    onAppleClick={handleAppleLogin}
    onMicrosoftClick={handleMicrosoftLogin}
    onGitHubClick={handleGitHubLogin}
    isLoading={isLoading}
  />
);

const AuthEmail: React.FC<{
  handleEmailLogin: (email: string, password?: string, displayName?: string, country?: string, stateCode?: string) => void;
  isLoading: boolean;
  error: string | undefined;
  setError: (error: string | undefined) => void;
}> = ({ handleEmailLogin, isLoading, error, setError }) => (
  <EmailSection
    onSubmit={(email, password, displayName, country, stateCode) => handleEmailLogin(email, password, displayName, country, stateCode)}
    isLoading={isLoading}
    externalError={error}
    onErrorClear={() => setError(undefined)}
  />
);

export const AuthModalContent: React.FC<AuthModalContentProps> = (props) => (
  <ModalContent onClose={props.onClose}>
    <AuthHeader onClose={props.onClose} />
    <AuthOAuth
      handleGoogleLogin={props.handleGoogleLogin}
      handleAppleLogin={props.handleAppleLogin}
      handleMicrosoftLogin={props.handleMicrosoftLogin}
      handleGitHubLogin={props.handleGitHubLogin}
      isLoading={props.isLoading}
    />
    <Divider />
    <AuthEmail
      handleEmailLogin={props.handleEmailLogin}
      isLoading={props.isLoading}
      error={props.error}
      setError={props.setError}
    />
  </ModalContent>
);
